import { ModuleContainer } from '../../layout/ModuleContainer.tsx';
import { ReviewModule } from '../../modules/review/ReviewModule.tsx';

export const ReviewRouteElement = () => (
  <ModuleContainer moduleID="review" compact overflow="hidden">
    <ReviewModule />
  </ModuleContainer>
);
